import React from "react";
import { FaBookmark, FaTags, FaChalkboard, FaPencilAlt } from "react-icons/fa";
import TabsBar from "./TabsBar";
import styles from "./styles/LeftSideBar.module.css";
import { useNavigate } from "react-router-dom";

const LeftSideBar = ({
  activeTab,
  setActiveTab,
  activeSubTab,
  setActiveSubTab,
  popularTags = [],
  onTagClick,
}) => {
  const navigate = useNavigate();

  const handleTagClick = (tag) => {
    setActiveTab('');
    setActiveSubTab('');
    navigate(`/browse/${encodeURIComponent(tag)}`);
  };

  const handleClickClassrooms = () => {
    navigate("/my-classrooms");
  };

  const handleClickSaved = () => { // Saved Navigation
    navigate("/saved");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <aside className={styles.leftPanel}>
      {/* Tabs */}
      <section className={styles.tabsSection}>
        <TabsBar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          activeSubTab={activeSubTab}
          setActiveSubTab={setActiveSubTab}
          isMinimized={false} 
        />
      </section>

      {/* You */}
      <section className={styles.you}>
        <div className={styles.leftTitle}>You</div>
        <button
          className={`${styles.youButton} ${isActive("/saved") ? styles.active : ""}`}
          onClick={handleClickSaved}
      >
          <FaBookmark className={styles.youIcon} />
          <span>Saved</span>
        </button>


        <button
          className={`${styles.youButton} ${isActive("/my-classrooms") ? styles.active : ""}`}
          onClick={handleClickClassrooms}
        >
          <FaChalkboard className={styles.icon} />
          <span>Classrooms</span>
        </button>
      </section>
    </aside>
  );
};

export default LeftSideBar;
